var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaxiIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Fill_Outline",
    "data-name": "Fill Outline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56,43h5V35.9A8.9,8.9,0,0,0,52.1,27l-3.214-.165-5.269-5.854A12.027,12.027,0,0,0,34.557,17l-10.929.11a10.97,10.97,0,0,0-6.141,1.978A9.028,9.028,0,0,0,13.85,23.73L12.543,27H9.562A6.562,6.562,0,0,0,3,33.562V43H56Z",
    style: {
      fill: "#f8cf26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.891,27H32V21h2c3.535,0,5.539,1.512,7.8,4.127h0A1.139,1.139,0,0,1,40.891,27Z",
    style: {
      fill: "#06aae9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 13,
    width: 11,
    height: 4,
    style: {
      fill: "#f7931e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,27H17v-.879A5.122,5.122,0,0,1,18.5,22.5h0A5.122,5.122,0,0,1,22.121,21H26Z",
    style: {
      fill: "#06aae9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,27.045v1.08A4.875,4.875,0,0,0,57.875,33h2.641A8.8,8.8,0,0,0,53,27.045Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 33,
    width: 5,
    height: 4,
    style: {
      fill: "#ed1c24"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 44,
    r: 7,
    style: {
      fill: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 44,
    r: 3,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 44,
    r: 7,
    style: {
      fill: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 44,
    r: 3,
    style: {
      fill: "#ccc"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.153,26h0l-2.8-.144L44.36,20.313a13.018,13.018,0,0,0-9.36-4.3V13a1,1,0,0,0-1-1H23a1,1,0,0,0-1,1v3.236a12.214,12.214,0,0,0-5.076,2.027,10.024,10.024,0,0,0-4,5.1L11.866,26h-2.3a7.572,7.572,0,0,0-7.524,6.811A1,1,0,0,0,2,33V43a1,1,0,0,0,1,1H9a7.976,7.976,0,0,0,2.726,6H2v2H62V50H54.274A7.976,7.976,0,0,0,57,44h4a1,1,0,0,0,1-1V35.9A9.9,9.9,0,0,0,52.153,26Zm6.808,6H57.875a3.873,3.873,0,0,1-3.863-3.756A7.92,7.92,0,0,1,58.961,32ZM24,14h9v2H24ZM7,34v2H4V34Zm4,10a6,6,0,1,1,6,6A6.006,6.006,0,0,1,11,44Zm11.274,6A7.976,7.976,0,0,0,25,44H41a7.976,7.976,0,0,0,2.726,6ZM49,50a6,6,0,1,1,6-6A6.006,6.006,0,0,1,49,50Zm11-8H56.737a7.988,7.988,0,0,0-15.474,0H24.737A7.988,7.988,0,0,0,9.263,42H4V38H8a1,1,0,0,0,1-1V33a1,1,0,0,0-1-1H4.227a5.571,5.571,0,0,1,5.335-4h2.98a1,1,0,0,0,.929-.629l1.321-3.3a8.044,8.044,0,0,1,3.259-4.152,9.994,9.994,0,0,1,5.587-1.8L34.567,18h.112a11.034,11.034,0,0,1,8.2,3.65L48.143,27.5a1,1,0,0,0,.691.33L52,28v.13A5.882,5.882,0,0,0,57.875,34h1.884A7.837,7.837,0,0,1,60,35.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,28h8.891a2.163,2.163,0,0,0,2-1.267,2.092,2.092,0,0,0-.328-2.26C40.169,21.711,37.9,20,34,20H32a1,1,0,0,0-1,1v6A1,1,0,0,0,32,28Zm1-6h1c3.172,0,4.924,1.329,7.045,3.781a.1.1,0,0,1,.022.121.176.176,0,0,1-.176.1H33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,28h9a1,1,0,0,0,1-1V21a1,1,0,0,0-1-1H22.121A6.122,6.122,0,0,0,16,26.121V27A1,1,0,0,0,17,28Zm2.207-4.793A4.153,4.153,0,0,1,22.121,22H25v4H18A4.089,4.089,0,0,1,19.207,23.207Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,40a4,4,0,1,0,4,4A4,4,0,0,0,17,40Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,17,46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,40a4,4,0,1,0,4,4A4,4,0,0,0,49,40Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,49,46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 29,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 31,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 29,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 31,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 29,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 31,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 29,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 31,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 29,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 31,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 29,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 31,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 29,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 31,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 29,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 31,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 29,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 31,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 29,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 31,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 29,
    width: 2,
    height: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxiIcon);
export default __webpack_public_path__ + "static/media/taxiIcon.9b5950b3bed0ea17c30b91d794ab579d.svg";
export { ForwardRef as ReactComponent };